import React from 'react';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import DialogHeader from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { closeUserFolio} from '../../redux/actions/controlbuttonaction'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { sidebarwith } from './const';
import { bgColors } from '../utils/bgColor';
import { useDispatch } from 'react-redux';
import { BootstrapDialog} from '../FormComopents/Form/CustomDialog';
// import { fetchrootpath } from '../api_servcies/apirootpath';
import UserPolyContainer from './Container/UserPolyContainer';
const drawerWidth = sidebarwith;

// const  UserPolygonListUrl  = `${fetchrootpath}/user_project`

const UserFolioWindow=(Props) =>{

const dispatch = useDispatch()
const {openUserFolio} = Props

return (
<BootstrapDialog
    onClose={() => dispatch(closeUserFolio)}
    aria-labelledby="customized-dialog-title"
    open={openUserFolio}
    scroll="paper"
    sx={{
        "& .MuiDialog-container": {
           alignItems: "flex-start",
           "& .MuiPaper-root": {
                  width: "100%",
                  minHeight:"200px",
                  marginTop:'0.25rem',
                  marginLeft:'0.5rem',
                  maxWidth: drawerWidth  // Set your width here
              
                },
        },
     }}
    
    PaperProps={{sx: 
      {position:'fixed' ,
      //  marginLeft:'0.5rem', 
       top:0, left:0} ,
       style:{borderRadius: 10,
       background:bgColors.default_backgroun_grey
    }}}
    >
  <DialogHeader style = {{padding:'1.25rem'}} >
   <Grid container spacing={2}  style={{alignItems:"center",justifyContent:'center'}}
       >
     <Grid item xs={11} container justifyContent="left">
     <Typography   
       style={{color:bgColors.font_blue, 
       fontSize: 30, 
       fontFamily: 'roboto'}}>
      User-folio
     </Typography>
     </Grid>
     <Grid item xs={1} container sx={{justifyContent:"flex-end", alignItems:"center"}}>
     <IconButton onClick={() => dispatch(closeUserFolio)}>
     <CloseSharpIcon fontSize='medium' 
      style={{color:bgColors.font_blue}}/>
     </IconButton>
     </Grid>
   </Grid>
    </DialogHeader>
    <DialogContent dividers >
    <UserPolyContainer/>
    </DialogContent>
  </BootstrapDialog>
  );
}
export default UserFolioWindow

